import { IODLayerName, ODDataType, ODYearType } from "./IODLayerName";

/** OD_Bゾーンレイヤ名 */
const LAYER_OD_BZONE_SHAPE = "t_od_bzone_shape";
/** OD_市区町村レイヤ名 */
const LAYER_OD_CITY_SHAPE = "t_od_city_shape";
/** OD_都道府県レイヤ名 */
const LAYER_OD_PREF_SHAPE = "t_od_pref_shape";

/**
 * ODゾーンレイヤ指定用クラス
 */
export class ODZoneLayerName implements IODLayerName {
  /**
   * データ種別
   */
  odDataType: ODDataType;

  /**
   * 年度
   */
  odYearType: ODYearType;

  /**
   * コンストラクタ
   * @param odDataType データ種別
   */
  constructor(odDataType: ODDataType, odYearType: ODYearType = "R03") {
    this.odDataType = odDataType;
    this.odYearType = odYearType;
  }

  /**
    * フィルタ条件文字列を取得
    */
  getCqlFilterString(): string {
    // 市区町村のみ年度のフィルタが不要
    if (this.odDataType == "市区町村") return "";

    return `"年度"='${this.odYearType}'`;
  }

  /**
    * レイヤ名を取得
    */
  getLayerName(): string {
    let layerName = "";
    if (this.odDataType === "Bゾーン") {
      layerName = LAYER_OD_BZONE_SHAPE;
    } else if (this.odDataType === "市区町村") {
      layerName = LAYER_OD_CITY_SHAPE;
    } else if (this.odDataType === "都道府県") {
      layerName = LAYER_OD_PREF_SHAPE
    }
    return layerName;
  }
}